/**
 * Environment-aware URLs for the Libby the Lion & Friends site.
 *
 * - `PUBLIC_SITE_ORIGIN`: this SPA’s origin (links, canonical, OG URL). Dev defaults to
 *   http://localhost:3001; production defaults to https://www.libbythelion.com.
 *   Override with REACT_APP_PUBLIC_SITE_URL when needed.
 *
 * - `NEWSLETTER_API_URL`: LibbyNewsletter.Api origin. Dev defaults to http://localhost:5144;
 *   production defaults to https://api.libbythelion.com. Override with
 *   REACT_APP_NEWSLETTER_API_URL (see `.env.example`). CORS on the API must allow PUBLIC_SITE_ORIGIN.
 */
function trimTrailingSlash(url) {
  return (url || '').replace(/\/$/, '');
}

function readEnvUrl(raw, fallback) {
  if (raw == null) return fallback();
  const trimmed = String(raw).trim();
  if (!trimmed) return fallback();
  return trimTrailingSlash(trimmed);
}

function inferPublicSiteOrigin() {
  return readEnvUrl(process.env.REACT_APP_PUBLIC_SITE_URL, () => {
    if (process.env.NODE_ENV === 'production') return 'https://www.libbythelion.com';
    return 'http://localhost:3001';
  });
}

function inferNewsletterApiUrl() {
  return readEnvUrl(process.env.REACT_APP_NEWSLETTER_API_URL, () => {
    if (process.env.NODE_ENV === 'production') return 'https://api.libbythelion.com';
    return 'http://localhost:5144';
  });
}

export const PUBLIC_SITE_ORIGIN = inferPublicSiteOrigin();
export const NEWSLETTER_API_URL = inferNewsletterApiUrl();

/** Canonical URL for the live homepage (initial launch). */
export const SITE_HOME_URL = `${PUBLIC_SITE_ORIGIN}/`;

/** Set to true to show the Videos pillar in the Discover section. */
export const SHOW_VIDEOS = false;

/** @deprecated Use SITE_HOME_URL — kept for older imports. */
export const COMING_SOON_PAGE_URL = SITE_HOME_URL;
